__turbopack_context__.v({
  "center": "index-module__vBe1pa__center",
  "contain": "index-module__vBe1pa__contain",
  "cover": "index-module__vBe1pa__cover",
  "inside": "index-module__vBe1pa__inside",
  "left": "index-module__vBe1pa__left",
  "pictureContain": "index-module__vBe1pa__pictureContain",
  "right": "index-module__vBe1pa__right",
});
